/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ManagerTeacher { 
    readonly id: number;
    /**
     * UUID of the user in auth-portal
     */
    userUuid: string;
    firstName?: string;
    lastName?: string;
    readonly groups: Array<string>;
    readonly lastEvaluationDate: Date;
    readonly resultsCount: number;
    readonly hasSharedResults: boolean;
}